export default __webpack_public_path__ + "static/media/Added.e8bb6a81.svg";